var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box", class: [_vm.loading ? "box-loading" : ""] },
    [
      _c(
        "div",
        { staticClass: "box-header" },
        [
          _vm._t("header"),
          _vm._v(" "),
          _vm.hideable
            ? _c("toggle", {
                staticClass: "pull right",
                attrs: {
                  sync: true,
                  labels: {
                    checked: _vm.resource("Bool_Hide"),
                    unchecked: _vm.resource("Bool_Show")
                  },
                  width: 78
                },
                model: {
                  value: _vm.show,
                  callback: function($$v) {
                    _vm.show = $$v
                  },
                  expression: "show"
                }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "body", staticClass: "box-body" },
        [
          _vm.loading ? _c("div", { staticClass: "loading-data" }) : _vm._e(),
          _vm._v(" "),
          _vm._t("body")
        ],
        2
      ),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c("div", { staticClass: "box-footer" }, [_vm._t("footer")], 2)
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }